import {
  getCourseMaterialOversizedFileMessage,
  isCourseMaterialFileOversized,
} from "../../../../constants/courseMaterialUploadLimits";

function setProgressIfMounted(e, mountedRef, setUploadProgress) {
  if (!e.lengthComputable || !mountedRef.current) {
    return;
  }
  const pct = Math.round((e.loaded / e.total) * 100);
  setUploadProgress(pct);
}

export async function uploadCourseFileWithProgress(file, apiUrl, deps) {
  const {
    currentUploadRef,
    lastAttemptedFileRef,
    setUploadProgress,
    setUploadStatus,
    setLastUploadError,
    setMensaje,
  } = deps;

  if (isCourseMaterialFileOversized(file)) {
    lastAttemptedFileRef.current = null;
    setUploadStatus("error");
    const msg = getCourseMaterialOversizedFileMessage();
    setLastUploadError(msg);
    setMensaje(`⚠️ ${msg}`);
    throw new Error(msg);
  }
  setUploadProgress(0);
  setUploadStatus("uploading");
  setLastUploadError("");
  lastAttemptedFileRef.current = file;
  try {
    const prepareResponse = await fetch(`${apiUrl}/subir-archivo-url`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nombre: file.name,
          tipo: file.type || "application/octet-stream",
          size: file.size,
        }),
      });
    const prepared = await prepareResponse.json().catch(() => ({}));
    if (!prepareResponse.ok || typeof prepared.uploadUrl !== "string") {
      const msg =
        typeof prepared.error === "string"
          ? prepared.error
          : `No se pudo preparar la subida (HTTP ${prepareResponse.status}).`;
      throw new Error(msg);
    }
    if (!deps.mountedRef.current) {
      throw new Error("Carga cancelada (componente desmontado).");
    }
    return await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", prepared.uploadUrl);
      xhr.setRequestHeader("Content-Type", prepared.tipo || file.type || "application/octet-stream");
      xhr.timeout = 60 * 60 * 1000;
      currentUploadRef.current = xhr;
      xhr.upload.onprogress = (event) => {
        setProgressIfMounted(event, deps.mountedRef, setUploadProgress);
      };
      xhr.onload = () => {
        if (!deps.mountedRef.current) return;
        if (xhr.status >= 200 && xhr.status < 300) {
          setUploadProgress(100);
          setUploadStatus("done");
          lastAttemptedFileRef.current = null;
          resolve({
            url: prepared.url,
            nombre: prepared.nombre,
            tipo: prepared.tipo,
          });
          return;
        }
        const msg = `Error al subir el archivo al almacenamiento (HTTP ${xhr.status}).`;
        setUploadStatus("error");
        setLastUploadError(msg);
        reject(new Error(msg));
      };
      xhr.onerror = () => {
        if (!deps.mountedRef.current) return;
        const msg = "Error de red durante la subida directa.";
        setUploadStatus("error");
        setLastUploadError(msg);
        reject(new Error(msg));
      };
      xhr.ontimeout = () => {
        if (!deps.mountedRef.current) return;
        const msg = "Tiempo de espera agotado durante la subida.";
        setUploadStatus("error");
        setLastUploadError(msg);
        reject(new Error(msg));
      };
      xhr.onloadend = () => {
        currentUploadRef.current = null;
      };
      xhr.send(file);
    });
  } catch (err) {
    setUploadStatus("error");
    setLastUploadError(err.message || "Error");
    throw err;
  }
}
